import MenuHint from './menu_hint';

// We need to ensure that any customer supplied search data is not injected as
// raw strings into HTML fragments (as that can lead to a XSS situation.) Using
// jQuery's .text property will ensure that any cusomter supplied data will be
// displayed only as text.
export default class RemoteMenuHint extends MenuHint {
  constructor($el, $container, token, params, query, input) {
    super($el, $container, token, params, query, input);
    this.selectOnEnter = true; // Configures behavior of parent class
    this.$breadcrumbs = this.$container.find('.breadcrumb-nav');
    this.$container.on(
      'click.breadcrumb-nav',
      'a.autocomplete-breadcrumb-nav',
      e => this.select(e.currentTarget.getAttribute('data-path')),
    );
  }

  destroy() {
    this.$container.off('click.menuhint', '.dropdown-item');
    this.$container.off('click.breadcrumb-nav');
  }

  setToken(token) {
    const oldToken = this.token;
    this.token = token;

    if (!this.setTokenCalledPreviously || oldToken.key() !== token.key()) {
      $.get(this.params.url, { token: token.text }, data => {
        if (this.token.text === data.token) {
          this.renderBreadcrumbs(data);
          this.renderCompletions(data);
        }
      });
    }
    this.setTokenCalledPreviously = true;
  }

  select(text) {
    const newToken = this.token.cloneWithNewKey(text);
    this.query.replaceToken(newToken, newToken.text.length);
  }

  renderBreadcrumbs(data) {
    this.$breadcrumbs.empty();

    const path = [];

    const links = data.token
      .split(':')[0]
      .split('.')
      .filter(x => !!x.trim())
      .flatMap(fragment => {
        path.push(fragment);

        return [
          $(`<a class="autocomplete-breadcrumb-nav btn btn-sm btn-info" href="#" data-path="${path.join('.')}.">`).text(fragment),
          " / "
        ];
      });

    if (links.length > 1) {
      links.pop();
      links.pop();
      links.push(
        $('<span>').text(this.token.text
            .split(':')[0] // The key part
            .replace(/\.+$/, '') // Remove any trailing periods in the key
            .split('.') // Split the key into segments
            .slice(-1)[0] // Get the last segment
        )
      );
      this.$breadcrumbs.append(links).show();
    } else {
      this.$breadcrumbs.hide();
    }
  }

  renderCompletions(data) {
    this.$dropdownParent.empty();
    if (data.terms.length > 0) {
      data.terms.slice(0, 10).forEach(item => {
        const pieces = item.split('.');
        const last = pieces.pop();

        const $pieces = $('<span class="text-canvas-800">').text(pieces.join('.'));
        const $last = $('<strong>').text(last);

        this.$dropdownParent.append(
          $(`<a class="dropdown-item list-group-item" href="#" data-term="${item}">`).append($pieces, ".", $last),
        );
      });

      if (data.terms.length > 10) {
        this.$dropdownParent.append(
          $('<div class="more">...type to see more matches</a>'),
        );
      }
    } else {
      this.$dropdownParent.append(
        $('<div class="no-autocomplete-matches">').text(`'${this.token.key()}' has no nested keys`)
      );
    }
  }
}
